<template>
    <div id="sign-in-outer-container">
        <div id="sign-in-page-container">
            <div id="text-box">
                <h1>Become a Member To Enjoy Extra Benefits</h1>
                <p>Unlimited Access to all options/darkpool commands and more!</p>
                <p>Sign in with Discord below to get Registered and set up.</p>
            </div>
            <img src="/assets/undraw_login.svg" id="illustration"/>
            <v-btn
                    large
                    class="ma-2 white--text"
                    id="discord-button"
                    v-on:click="signPressed()"
            >
                Sign In With Discord
                <img class="right-side-button-icon" src="../../assets/Discord-Logo-White.svg" alt="Discord Logo">
            </v-btn>
        </div>
    </div>
</template>

<script>
import {CLIENT_ID} from "../../utils/constants";
import {BASE_URL} from "../../utils/constants"

const ENDPOINT = "registration"

export default {
    name: "Login",
    methods: {
        signPressed: function() {
            window.location = `https://discord.com/api/oauth2/authorize?client_id=${CLIENT_ID}&response_type=code&scope=identify+email&redirect_uri=${BASE_URL + ENDPOINT}`
        }
    }
}
</script>

<style scoped>
    p {
        font-size: 20px;
        color: #9E9E9E;
    }

    #sign-in-outer-container {
        height: 100%;
        width: 100%;
    }

    #sign-in-page-container {
        height: 100%;
        width: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        padding: 16px;
    }

    #text-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }

    #illustration {
        width: 80%;
        height: auto;
        margin: 2rem 0;
    }

    #discord-button {
        position: relative;
        width: 100%;
        height: 52px;
        background-color: #7289DA;
    }

    .right-side-button-icon {
        position: absolute;
        height: 30px;
        right: 0;
    }


    @media screen and (min-width: 750px) {

        #sign-in-outer-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        #sign-in-page-container {
            width: 50%;
            max-width: 564px;
            margin: auto;
            height: fit-content;
            background-color: #404040;
            padding: 32px;
            border-radius: 10px;
            box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
        }
    }

</style>